export default __webpack_public_path__ + "static/media/pic3.aff54a07.jpg";